export default {"src":"/oferta/_next/static/media/lactose-intolerant.86270233.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};